var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.904 13.3145H12.096C6.63598 13.3145 2.09998 17.7665 2.09998 23.3105V60.6905C2.09998 66.1505 6.55198 70.6865 12.096 70.6865H71.904C77.364 70.6865 81.9 66.2345 81.9 60.6905V23.2265C81.9 17.7665 77.448 13.3145 71.904 13.3145ZM27.048 25.7465C31.164 25.7465 34.524 29.1065 34.524 33.2225C34.524 37.3385 31.164 40.6985 27.048 40.6985C22.932 40.6985 19.572 37.3385 19.572 33.2225C19.572 29.1065 22.932 25.7465 27.048 25.7465ZM39.732 58.1705H14.364C13.608 58.1705 12.852 57.8345 12.432 57.2465C11.928 56.6585 11.76 55.9025 12.012 55.1465C13.692 48.1745 19.908 43.2185 27.132 43.2185C34.104 43.2185 40.152 47.8385 42 54.5585C42.168 54.8945 42.252 55.2305 42.252 55.6505C42.252 57.0785 41.16 58.1705 39.732 58.1705ZM56.952 48.1745H46.956C45.612 48.1745 44.436 47.0825 44.436 45.6545C44.436 44.3105 45.528 43.1345 46.956 43.1345H56.952C58.296 43.1345 59.472 44.2265 59.472 45.6545C59.472 47.0825 58.38 48.1745 56.952 48.1745ZM69.468 38.1785H46.956C45.612 38.1785 44.436 37.0865 44.436 35.6585C44.436 34.3145 45.528 33.1385 46.956 33.1385H69.384C70.728 33.1385 71.904 34.2305 71.904 35.6585C71.904 37.0865 70.812 38.1785 69.468 38.1785Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancard);
export default __webpack_public_path__ + "static/media/pancard.9ee7bc9396c1c142ba11e48f3603e199.svg";
export { ForwardRef as ReactComponent };